<div class="balance-65-logo">
    <div class="balance-65-logo-icon"></div>
    <div class="balance-65-logo-title" [innerHTML]="TEXT.header.balance"></div>
</div>
